/**
 * VIB-790/791: Validation utilities for time entries.
 */

/**
 * Returns an error message if a comment is required but missing,
 * or null if the entry is valid.
 *
 * Interne prosjekter OG T&M-prosjekter (project_type='hourly') krever en
 * ikke-tom kommentar på hver tidsregistrering, så admin forstår hva tiden gikk
 * til, og for T&M-fakturalinjer (VIB-790/791). Vanlige (fixed) tildelte
 * oppgaver krever IKKE kommentar. NB: DB-triggeren
 * assert_internal_time_entry_has_comment håndhever kun interne — T&M-kravet er
 * klient-side.
 */
export function commentRequiredForProject(
  project: { is_internal?: boolean | null; project_type?: string | null } | null | undefined,
): boolean {
  return project?.is_internal === true || project?.project_type === 'hourly';
}

export function requireCommentForTrackedProject(
  project: { is_internal?: boolean | null; project_type?: string | null } | null | undefined,
  comment: string | null | undefined,
): string | null {
  if (!project) return null;
  const requires = commentRequiredForProject(project);
  if (!requires) return null;
  if (!comment || !comment.trim()) {
    return "Kommentar er påkrevd for internprosjekt og T&M-prosjekter";
  }
  return null;
}

/** VIB-909: reisetid (medgått) krever alltid kommentar. */
export function requireCommentForReisetid(comment: string | null | undefined): string | null {
  if (!comment || !comment.trim()) return "Kommentar er påkrevd for reisetid";
  return null;
}

/**
 * @deprecated Bruk requireCommentForTrackedProject i stedet.
 * Beholdt for bakoverkompatibilitet.
 */
export function requireCommentForInternal(
  isInternal: boolean,
  comment: string | null | undefined,
): string | null {
  return requireCommentForTrackedProject({ is_internal: isInternal }, comment);
}
